module.exports = __webpack_public_path__ + "img/ugly.be5030ca.webp";